import { AxiosError } from "axios";
import { useCallback } from "react";
import { useAlert } from "capitalrx-components-2.0/lib/general";

export function useFailureHandler(): (err: string | AxiosError) => void {
  const showAlert = useAlert();
  return useCallback(
    (err: string | AxiosError): void => {
      showAlert({
        message: typeof err === "string" ? err : (err.response?.data as { message?: string })?.message || err.message,
        type: "error",
        style: "banner",
      });
    },
    [showAlert],
  );
}
